var React = require('react');

function Star (props) {
    return React.createElement("svg",props,[React.createElement("g",{"clipPath":"url(#clip0_2303_22342)","key":0},React.createElement("path",{"d":"M13.2845 0.601562L13.6131 12.0589L19.626 2.30107L14.1815 12.3875L24.2679 6.94303L14.5101 12.9559L25.9674 13.2845L14.5101 13.6131L24.2679 19.626L14.1815 14.1815L19.626 24.2679L13.6131 14.5101L13.2845 25.9674L12.9559 14.5101L6.94303 24.2679L12.3875 14.1815L2.30107 19.626L12.0589 13.6131L0.601562 13.2845L12.0589 12.9559L2.30107 6.94303L12.3875 12.3875L6.94303 2.30107L12.9559 12.0589L13.2845 0.601562Z","fill":"#F7C800"})),React.createElement("defs",{"key":1},React.createElement("clipPath",{"id":"clip0_2303_22342"},React.createElement("rect",{"width":"25.3659","height":"25.3659","fill":"white","transform":"translate(0.601562 0.601562)"})))]);
}

Star.defaultProps = {"width":"26","height":"26","viewBox":"0 0 26 26","fill":"none"};

module.exports = Star;

Star.default = Star;
